/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";

import { VERIFY_USER } from "../../Events";

import axios from "axios";

import { toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class LoginFrom extends Component {
  state = {
    nicname: "",
    icon: "",
    error: "",
  };
  _isMounted = false;

  componentDidMount = () => {
    this._isMounted = true;
    //const { loginId, nicName, icon } = this.props;
    ////console.log(nicName, loginId, icon)
    //console.log('로그인 화면 로드.....')
    this._getNicname();
    this.textInput.focus();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getNicname = async () => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === "") {
      //alert('로그인 후 이용할 수 있습니다.')
      toast.warn("로그인 후 이용이 가능합니다.");
    } else {
      const result = await this._getNicnameApi();
      const intReturn = result.data[0].intReturn;
      const infoData = result.data[0].listData;
      //console.log(infoData)

      if (intReturn === 0) {
        if (this._isMounted) {
          this.setState({
            nicname: infoData[0].nicName,
            icon: infoData[0].icon,
          });
          //console.log('로그인 서브밋...')
          this.handleSubmit();
        }
      }
    }
  };
  _getNicnameApi = () => {
    const { apiUrl, loginId } = this.props;
    //console.log(apiUrl + '/nicnameIcon?userid=' + loginId)
    return axios(apiUrl + "/nicnameIcon?userid=" + loginId)
      .then((response) => response)
      .catch((error) => {
        //console.log('get info error')
      });
  };

  setUser = ({ user, isUser }) => {
    ////console.log(user, isUser)

    if (isUser) {
      //console.log("user name taken")
      //this.setError("user name taken")
      this.props.childProps.getConnect();
    } else {
      ////console.log("chat enter....")
      this.setError("");
      this.props.childProps.setUser(user);
    }
  };

  handleSubmit = (e) => {
    //e.preventDefault()

    const { socket } = this.props.childProps;
    const { nicname, icon } = this.state;

    //this._connectCheck()
    ////console.log(this.setUser)
    //if(this.setUser) {
    //alert('이미 채팅에 참여하고 있는 아이디 입니다.')
    //logout()
    //} else {
    socket.emit(VERIFY_USER, nicname, icon, this.setUser);
    //console.log('소켓 전송...')
    //}
  };

  handleChange = (e) => {
    this.setState({
      nicname: e.target.value,
    });
  };
  setError = (error) => {
    this.setState({
      error,
    });
  };
  render() {
    const { nicname, icon, error } = this.state;
    return (
      <Fragment>
        <div className="login" style={{ display: "none" }}>
          <form onSubmit={this.handleSubmit} className="login-form">
            <label htmlFor="nicname">
              <h2>채팅방 입장하기</h2>
            </label>
            <img
              src={icon}
              style={{ width: 200, height: 200, borderRadius: 100 }}
            />
            <input
              ref={(input) => (this.textInput = input)}
              type="text"
              id="nicname"
              value={nicname ? nicname : ""}
              onChange={this.handleChange}
              placeholder={"input nicname!"}
              readOnly
            />
            <button>수다 떨러 갑시다~~</button>
            <div className="error">{error ? error : null}</div>
          </form>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(LoginFrom));
